import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamPLL() {
  return (
    <div className={styles["declaration"]}>
      <h1>Compliance-Erklärung für die Schulung und Prüfung von Promotern</h1>

      <p>
        Um die Servicequalität der Drittpromotoren an vorderster Front kontinuierlich zu verbessern, bietet das Schulungsteam der internationalen Abteilung von Xiaomi (im Folgenden als „wir“ oder „unser Unternehmen“ bezeichnet) Schulungskurse und begleitende Wissensvertiefungsprüfungen für die von externen Dienstleistern benannten Drittpromotoren (im Folgenden als „Teilnehmer“ bezeichnet) an. Ziel der Schulung und Prüfung ist es, die Kursinhalte zu optimieren und die Lernergebnisse zu festigen, und stellt keine Form eines Arbeitsverhältnisses oder tatsächlichen Managementverhaltens dar. Nachfolgend finden Sie die Erklärung zur Schulung und Prüfung:
      </p>

      <ol>
        <li>
          <strong>Natur der Schulung und Prüfung</strong><br/>
          Alle Schulungskurse und Prüfungen dienen dem Zweck der Wissensvermittlung und sollen den Teilnehmern helfen, Produktinformationen und Servicestandards systematisch zu verstehen. Die Prüfungsergebnisse spiegeln nur das Verständnis der Teilnehmer bezüglich der Schulungsinhalte wider und dürfen nicht als Grundlage für Leistungsbewertungen dienen. Wir haben keine Befugnis und werden uns nicht in die Leistungsbewertungen, Gehaltsverteilungen oder andere arbeitsrechtliche Angelegenheiten der Teilnehmer durch die externen Dienstleister einmischen.
        </li>
        <li>
          <strong>Klärung des Rechtsverhältnisses</strong><br/>
          Das Arbeitgeber-Arbeitnehmer-Verhältnis zwischen den Teilnehmern und ihren jeweiligen externen Dienstleistern bleibt von diesem Schulungs- und Prüfungsprogramm unberührt. Es besteht kein Arbeitgeber-Arbeitnehmer-Verhältnis zwischen unserem Unternehmen und den Teilnehmern, noch begründet dieses Wissensvermittlungsprogramm ein faktisches Arbeitsverhältnis mit den Teilnehmern.
        </li>
        <li>
          <strong>Verwendung der Prüfungsergebnisse</strong><br/>
          Die Prüfungsergebnisse dürfen nur für folgende Zwecke verwendet werden:
          <ol type="1">
            <li>Als Referenz für die interne Kursoptimierung und -verbesserung unseres Unternehmens;</li>
            <li>Den externen Dienstleistern als Nachweis der beruflichen Kompetenz der Teilnehmer vorgelegt werden, vorbehaltlich der unabhängigen Beurteilung und des Willens der externen Dienstleister;</li>
            <li>Die Prüfungsergebnisse werden nicht veröffentlicht oder an Dritte weitergegeben.</li>
          </ol>
        </li>
      </ol>

      <p>
        Diese Erklärung tritt mit dem Datum der Veröffentlichung in Kraft. Die Teilnahme am Schulungs- und Prüfungsprogramm stellt die Anerkennung und Annahme dieser Erklärung durch die Teilnehmer dar. Unser Unternehmen behält sich das endgültige Recht zur Auslegung und angemessenen Änderung dieser Erklärung vor.
      </p>

      <div className={styles["footer"]}>
        Schulungsteam der internationalen Abteilung von Xiaomi<br/>
        Datum: {getLocalizedTime('de-DE')}
      </div>
    </div>
  );
}